/* eslint-disable simple-import-sort/imports -- Sentry.init must run before the app modules evaluate */
import './instrument';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';

import App from './App';

import './styles/index.css';
import './styles/components.css';
import './styles/fonts.css';
import './styles/contract/index.css';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container, {
    onUncaughtError: reactErrorHandler(),
    onRecoverableError: reactErrorHandler(),
  });
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
